import React, { useState, useEffect } from "react";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import apiConfig from "../../apiConfig";

const ViewProduct = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedImage, setSelectedImage] = useState(null);
  const [searchCategory, setSearchCategory] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const [pageShow, setPageShow] = useState(true);

  const _searchProduct = async () => {
    try {
      const res = await axios.get(
        `${apiConfig.baseUrl}${apiConfig.SearchByProduct}?query=${searchCategory}`,
      );
      setProducts(res.data.data);
      setLoading(false);
    } catch (err) {
      console.error(err);
    }
  };

  const fetchProducts = async (page = 1) => {
    try {
      const res = await axios.get(
        `${apiConfig.baseUrl}${apiConfig.getAllProduct}?page=${page}&limit=16`,
      );
      setProducts(res.data.data);
      setTotalPages(res.data.totalPages);
      setLoading(false);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    if (searchCategory) {
      _searchProduct();
      setPageShow(false);
    } else {
      fetchProducts(currentPage);
      setPageShow(true);
    }
  }, [searchCategory, currentPage]);

  const handleRefresh = async () => {
    setSearchCategory("");
    sessionStorage.removeItem("searchCategory");
    fetchProducts(1);
    setCurrentPage(1);
  };

  return (
    <div className="p-4">
      {/* Header */}
      <div className="flex justify-start gap-4 mb-4">
        <div className="">
          <input
            type="text"
            placeholder="Search Product Name.."
            value={searchCategory}
            onChange={(e) => setSearchCategory(e.target.value)}
            className="border px-3 py-2 pr-8 rounded"
          />
          {searchCategory && (
            <button
              onClick={() => setSearchCategory("")}
              className="absolute right-2 top-1/2 -translate-y-1/2 text-gray-500"
            >
              ×
            </button>
          )}
        </div>
        <button
          onClick={handleRefresh}
          className="bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded"
        >
          Refresh Data
        </button>
      </div>

      {loading ? (
        <p>Loading...</p>
      ) : (
        <div className="w-full overflow-x-auto border bg-white rounded-md scrollbar-thin">
          <table className="min-w-[600px] w-full border-collapse text-sm">
            <thead className="bg-gray-200">
              <tr>
                <th className="border p-2">ID</th>
                <th className="border p-2">Name</th>
                <th className="border p-2">Brand</th>
                <th className="border p-2">Description</th>
                <th className="border p-2">Regular Price</th>
                <th className="border p-2">Sale Price</th>
                <th className="border p-2">Specifications</th>
                <th className="border p-2">Stock</th>
                <th className="border p-2">Discount</th>
                <th className="border p-2">Category</th>
                <th className="border p-2">SubCategory</th>
                <th className="border p-2">Images</th>
                <th className="border p-2">Size</th>
                <th className="border p-2">SKU</th>
                <th className="border p-2">GTIN</th>
                <th className="border p-2">ACTION</th>
              </tr>
            </thead>

            <tbody>
              {products.map((product) => (
                <tr key={product._id}>
                  <td className=" p-2">{product._id}</td>
                  <td className=" p-2  w-[300px] line-clamp-6">
                    {product.title}
                  </td>
                  <td className=" p-2">{product.brand}</td>
                  <td className="p-2 text-red-500 w-[300px]">
                    <div className="max-h-[200px] w-full overflow-y-auto pr-4">
                      {product.description}
                    </div>
                  </td>
                  <td className=" p-2">₹{product.regularPrice}</td>
                  <td className=" p-2">₹{product.salePrice}</td>

                  <td className="border p-2">
                    <table className="w-full border">
                      <thead>
                        <tr>
                          <th className="border p-1">Key</th>
                          <th className="border p-1">Value</th>
                        </tr>
                      </thead>
                      <tbody>
                        {product.specifications?.map((s, i) => (
                          <tr key={i}>
                            <td className="border p-1">{s.key}</td>
                            <td className="border p-1">
                              {s.values.join(", ")}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </td>

                  <td className="border p-2">{product.stock}</td>
                  <td className="border p-2">{product.discount}</td>
                  <td className="border p-2">{product.category}</td>
                  <td className="border p-2">{product.subcategory}</td>

                  {/* Image */}
                  <td className="border p-2">
                    <img
                      src={product.images?.[0]}
                      className="w-12 h-12 cursor-pointer"
                      onClick={() => setSelectedImage(product.images?.[0])}
                    />
                  </td>

                  <td className="border p-2">{product.size?.join(", ")}</td>

                  <td className="border p-2">{product.sku}</td>
                  <td className="border p-2">{product.gtin}</td>
                  <td className="border p-2">
                    <button
                      onClick={() =>
                        navigate(`/reseller/ResellProduct/${product._id}`)
                      }
                      className="bg-blue-600 hover:bg-blue-700 text-white px-3 py-1 rounded"
                    >
                      Add To Sell
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {/* Pagination */}
      {pageShow && (
        <div className="mt-5 flex items-center flex-wrap gap-2">
          {/* Previous */}
          <button
            onClick={() => setCurrentPage((p) => p - 1)}
            disabled={currentPage === 1}
            className="px-4 py-2 rounded bg-blue-500 text-white disabled:bg-gray-300"
          >
            Previous
          </button>

          {/* Page Numbers */}
          {Array.from({ length: totalPages }, (_, i) => i + 1)
            .filter((pageNum) => {
              if (totalPages <= 5) return true;
              if (currentPage <= 3) return pageNum <= 5;
              if (currentPage >= totalPages - 2)
                return pageNum > totalPages - 5;

              return pageNum >= currentPage - 2 && pageNum <= currentPage + 2;
            })
            .map((pageNum) => (
              <button
                key={pageNum}
                onClick={() => setCurrentPage(pageNum)}
                className={`px-3 py-2 rounded border ${
                  currentPage === pageNum
                    ? "bg-blue-500 text-white border-blue-700 font-bold"
                    : "bg-white text-black border-gray-300"
                }`}
              >
                {pageNum}
              </button>
            ))}

          {/* Next */}
          <button
            onClick={() => setCurrentPage((p) => p + 1)}
            disabled={currentPage === totalPages}
            className="px-4 py-2 rounded bg-blue-500 text-white disabled:bg-gray-300"
          >
            Next
          </button>
        </div>
      )}

      {/* Image Modal (Tailwind) */}
      {selectedImage && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center">
          <div className="bg-white p-4 rounded">
            <img src={selectedImage} className="w-[400px]" />
            <button
              className="mt-2 bg-gray-800 text-white px-4 py-2"
              onClick={() => setSelectedImage(null)}
            >
              Close
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ViewProduct;
